import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimationLoader, LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

import { TravelLoaderComponent } from '@ux/components/travel-loader/travel-loader.component';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    TravelLoaderComponent
  ],
  imports: [
    CommonModule,
    LottieComponent,
  ],
  exports: [
    TravelLoaderComponent
  ],
  providers: [
    DomManipulateService,
    provideLottieOptions({ player: () => player }),
    AnimationLoader,
  ]
})
export class TravelLoaderModule { }
